// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__Qny09","inputWrap":"styles_inputWrap__2qyBi","input":"styles_input__ze64I"};